import { render, staticRenderFns } from "./CoDashboard.vue?vue&type=template&id=4f8a0fae&"
import script from "./CoDashboard.vue?vue&type=script&lang=ts&"
export * from "./CoDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports